import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { usePostHog } from "posthog-js/react";
import { useTheme } from "next-themes";
import { Button } from "@repo/blacksmith-ui/button";
import { BlackGitHubIcon, WhiteGitHubIcon } from "@/components/GitHubIcon";
import { AnimatedBlacksmithLogoOneline, BlacksmithLogomarkAnimationSVG } from "@/components/BlacksmithLogoSVG";
import { CORE_ANALYTICS_EVENTS } from "@/lib/posthog-constants";
import { useDashboardSearchParams as useSearchParams } from "@/hooks/useDashboardNavigation";
import { withFirstTouchRdtCid } from "@/lib/appFirstTouchAttribution";
import { codesmithDesktopBridge, useCodesmithSurface } from "@/lib/codesmithSurface";
export function WorkOSLoginCard() {
  const $ = _c(16);
  const [isLoading, setIsLoading] = useState(false);
  const posthog = usePostHog();
  const {
    resolvedTheme
  } = useTheme();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("embed");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const surface = useCodesmithSurface(t0);
  let t1;
  if ($[2] !== posthog || $[3] !== surface) {
    t1 = () => {
      setIsLoading(true);
      posthog?.capture(CORE_ANALYTICS_EVENTS.LOGIN_BUTTON_CLICK, {
        authentication_provider: "workos"
      });
      const redirectUrl = encodeURIComponent(withFirstTouchRdtCid(window.location.href));
      const loginUrl = `${process.env.NEXT_PUBLIC_API_URL}/login/github?redirect=${redirectUrl}`;
      if (surface === "desktop") {
        codesmithDesktopBridge()?.startLogin();
        setIsLoading(false);
        return;
      }
      if (surface === "extension") {
        window.open(loginUrl, "_blank");
        setIsLoading(false);
        return;
      }
      window.location.href = loginUrl;
    };
    $[2] = posthog;
    $[3] = surface;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleGithubLogin = t1;
  if (isLoading) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="flex h-screen items-center justify-center"><div className="w-32 h-32"><BlacksmithLogomarkAnimationSVG /></div></div>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-48 mx-auto py-4 mb-0 text-neutral-900 dark:text-blacksmith-yellow"><AnimatedBlacksmithLogoOneline /></div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="-mt-4 flex flex-col text-neutral-800 dark:text-white"><span className="text-xl font-medium">Sign in</span><span className="text-sm text-neutral-500 dark:text-neutral-400">to continue to Blacksmith</span></div>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== resolvedTheme) {
    t4 = <>{resolvedTheme === "dark" ? <BlackGitHubIcon /> : <WhiteGitHubIcon />}Continue with GitHub</>;
    $[8] = resolvedTheme;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== handleGithubLogin || $[11] !== t4) {
    t5 = <Button onClick={handleGithubLogin} className="flex gap-2" variant="default" data-test="github-login-button">{t4}</Button>;
    $[10] = handleGithubLogin;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="-mt-2 block text-sm text-neutral-500 dark:text-neutral-400">No account? We'll create one for you.</span>;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5) {
    t7 = <div className="w-[360px] flex flex-col gap-6 text-center rounded-xl border border-[var(--color-border)] bg-[var(--color-surface)] p-8">{t2}{t3}{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}